import { Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[highlighted]', // This matches elements with the attribute
})
export class InputIconHighlightedDirective {
  constructor(public el: ElementRef) {}
}
